"use strict";

document.addEventListener("DOMContentLoaded", function (event) {
  var sizeMapping = [
    {
      distance: 9,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 10,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 11,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 12,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 13,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 14,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 15,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 16,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 17,
      opt1: "Small",
      opt2: "Medium",
      opt3: "None",
    },
    {
      distance: 18,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 19,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 20,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 21,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 22,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 23,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 24,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 25,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 26,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 27,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 28,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 29,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 30,
      opt1: "Small",
      opt2: "Medium",
      opt3: "Poster",
    },
    {
      distance: 31,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 32,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 33,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 34,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 35,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 36,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 37,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 38,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 39,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 40,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 41,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 42,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 43,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 44,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 45,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 46,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 47,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 48,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 49,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 50,
      opt1: "Medium",
      opt2: "Poster",
      opt3: "None",
    },
    {
      distance: 51,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 52,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 53,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 54,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 55,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 56,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 57,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 58,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 59,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 60,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 61,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 62,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 63,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 64,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 65,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 66,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 67,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 68,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 69,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 70,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 71,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 72,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 73,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 74,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 75,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 76,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 77,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 78,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 79,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 80,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 81,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 82,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 83,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 84,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 85,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 86,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 87,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 88,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 89,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 90,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 91,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
    {
      distance: 92,
      opt1: "Poster",
      opt2: "None",
      opt3: "None",
    },
  ];
  var smallProductList = [
    {
      prod: "_001",
      size: "Small",
      height: 15,
      minHeight: 9,
      width: 15,
      minWidth: 9,
      frameConfig: "15x15",
      minFrameConfig: "9x9",
      check: "Yes",
    },
    {
      prod: "_002",
      size: "Small",
      height: 15,
      minHeight: 9,
      width: 21,
      minWidth: 15,
      frameConfig: "15x21",
      minFrameConfig: "9x15",
      check: "Yes",
    },
    {
      prod: "_003",
      size: "Small",
      height: 15,
      minHeight: 9,
      width: 30,
      minWidth: 24,
      frameConfig: "15x30",
      minFrameConfig: "9x24",
      check: "Yes",
    },
    {
      prod: "_004",
      size: "Small",
      height: 21,
      minHeight: 15,
      width: 15,
      minWidth: 9,
      frameConfig: "21x15",
      minFrameConfig: "15x9",
      check: "Yes",
    },
    {
      prod: "_005",
      size: "Small",
      height: 21,
      minHeight: 15,
      width: 21,
      minWidth: 15,
      frameConfig: "21x21",
      minFrameConfig: "15x15",
      check: "Yes",
    },
    {
      prod: "_006",
      size: "Small",
      height: 21,
      minHeight: 15,
      width: 30,
      minWidth: 24,
      frameConfig: "21x30",
      minFrameConfig: "15x24",
      check: "Yes",
    },
    {
      prod: "_007",
      size: "Small",
      height: 30,
      minHeight: 24,
      width: 15,
      minWidth: 9,
      frameConfig: "30x15",
      minFrameConfig: "24x9",
      check: "Yes",
    },
    {
      prod: "_008",
      size: "Small",
      height: 30,
      minHeight: 24,
      width: 21,
      minWidth: 15,
      frameConfig: "30x21",
      minFrameConfig: "24x15",
      check: "Yes",
    },
    {
      prod: "_009",
      size: "Small",
      height: 30,
      minHeight: 24,
      width: 30,
      minWidth: 24,
      frameConfig: "30x30",
      minFrameConfig: "24x24",
      check: "Yes",
    },
  ];
  var mediumProductList = [
    {
      prod: "_010",
      size: "Medium",
      height: 21,
      minHeight: 9,
      width: 21,
      minWidth: 9,
      frameConfig: "21x21",
      minFrameConfig: "9x9",
      check: "Yes",
    },
    {
      prod: "_011",
      size: "Medium",
      height: 21,
      minHeight: 9,
      width: 30,
      minWidth: 18,
      frameConfig: "21x30",
      minFrameConfig: "9x18",
      check: "Yes",
    },
    {
      prod: "_012",
      size: "Medium",
      height: 30,
      minHeight: 18,
      width: 21,
      minWidth: 9,
      frameConfig: "30x21",
      minFrameConfig: "18x9",
      check: "Yes",
    },
    {
      prod: "_013",
      size: "Medium",
      height: 21,
      minHeight: 9,
      width: 42,
      minWidth: 30,
      frameConfig: "21x42",
      minFrameConfig: "9x30",
      check: "Yes",
    },
    {
      prod: "_014",
      size: "Medium",
      height: 42,
      minHeight: 30,
      width: 21,
      minWidth: 9,
      frameConfig: "42x21",
      minFrameConfig: "30x9",
      check: "Yes",
    },
    {
      prod: "_015",
      size: "Medium",
      height: 21,
      minHeight: 9,
      width: 50,
      minWidth: 38,
      frameConfig: "21x50",
      minFrameConfig: "9x38",
      check: "Yes",
    },
    {
      prod: "_016",
      size: "Medium",
      height: 50,
      minHeight: 38,
      width: 21,
      minWidth: 9,
      frameConfig: "50x21",
      minFrameConfig: "38x9",
      check: "Yes",
    },
    {
      prod: "_017",
      size: "Medium",
      height: 30,
      minHeight: 18,
      width: 30,
      minWidth: 18,
      frameConfig: "30x30",
      minFrameConfig: "18x18",
      check: "Yes",
    },
    {
      prod: "_018",
      size: "Medium",
      height: 30,
      minHeight: 18,
      width: 42,
      minWidth: 30,
      frameConfig: "30x42",
      minFrameConfig: "18x30",
      check: "Yes",
    },
    {
      prod: "_019",
      size: "Medium",
      height: 42,
      minHeight: 30,
      width: 30,
      minWidth: 18,
      frameConfig: "42x30",
      minFrameConfig: "30x18",
      check: "Yes",
    },
    {
      prod: "_020",
      size: "Medium",
      height: 30,
      minHeight: 18,
      width: 50,
      minWidth: 38,
      frameConfig: "30x50",
      minFrameConfig: "18x38",
      check: "Yes",
    },
    {
      prod: "_021",
      size: "Medium",
      height: 50,
      minHeight: 38,
      width: 30,
      minWidth: 18,
      frameConfig: "50x30",
      minFrameConfig: "38x18",
      check: "Yes",
    },
    {
      prod: "_022",
      size: "Medium",
      height: 42,
      minHeight: 30,
      width: 42,
      minWidth: 30,
      frameConfig: "42x42",
      minFrameConfig: "30x30",
      check: "Yes",
    },
    {
      prod: "_023",
      size: "Medium",
      height: 42,
      minHeight: 30,
      width: 50,
      minWidth: 38,
      frameConfig: "42x50",
      minFrameConfig: "30x38",
      check: "Yes",
    },
    {
      prod: "_024",
      size: "Medium",
      height: 50,
      minHeight: 38,
      width: 42,
      minWidth: 30,
      frameConfig: "50x42",
      minFrameConfig: "38x30",
      check: "Yes",
    },
    {
      prod: "_025",
      size: "Medium",
      height: 50,
      minHeight: 38,
      width: 50,
      minWidth: 38,
      frameConfig: "50x50",
      minFrameConfig: "38x38",
      check: "Yes",
    },
  ];
  var posterProductList = [
    {
      prod: "_026",
      size: "Poster",
      height: 32,
      minHeight: 18,
      width: 32,
      minWidth: 18,
      frameConfig: "32x32",
      minFrameConfig: "18x18",
      check: "Yes",
    },
    {
      prod: "_027",
      size: "Poster",
      height: 32,
      minHeight: 18,
      width: 42,
      minWidth: 28,
      frameConfig: "32x42",
      minFrameConfig: "18x28",
      check: "Yes",
    },
    {
      prod: "_028",
      size: "Poster",
      height: 42,
      minHeight: 28,
      width: 32,
      minWidth: 18,
      frameConfig: "42x32",
      minFrameConfig: "28x18",
      check: "Yes",
    },
    {
      prod: "_029",
      size: "Poster",
      height: 32,
      minHeight: 18,
      width: 52,
      minWidth: 38,
      frameConfig: "32x52",
      minFrameConfig: "18x38",
      check: "Yes",
    },
    {
      prod: "_030",
      size: "Poster",
      height: 52,
      minHeight: 38,
      width: 32,
      minWidth: 18,
      frameConfig: "52x32",
      minFrameConfig: "38x18",
      check: "Yes",
    },
    {
      prod: "_031",
      size: "Poster",
      height: 32,
      minHeight: 18,
      width: 62,
      minWidth: 48,
      frameConfig: "32x62",
      minFrameConfig: "18x48",
      check: "Yes",
    },
    {
      prod: "_032",
      size: "Poster",
      height: 62,
      minHeight: 48,
      width: 32,
      minWidth: 18,
      frameConfig: "62x32",
      minFrameConfig: "48x18",
      check: "Yes",
    },
    {
      prod: "_033",
      size: "Poster",
      height: 32,
      minHeight: 18,
      width: 72,
      minWidth: 58,
      frameConfig: "32x72",
      minFrameConfig: "18x58",
      check: "Yes",
    },
    {
      prod: "_034",
      size: "Poster",
      height: 72,
      minHeight: 58,
      width: 32,
      minWidth: 18,
      frameConfig: "72x32",
      minFrameConfig: "58x18",
      check: "Yes",
    },
    {
      prod: "_035",
      size: "Poster",
      height: 32,
      minHeight: 18,
      width: 82,
      minWidth: 68,
      frameConfig: "32x82",
      minFrameConfig: "18x68",
      check: "Yes",
    },
    {
      prod: "_036",
      size: "Poster",
      height: 82,
      minHeight: 68,
      width: 32,
      minWidth: 18,
      frameConfig: "82x32",
      minFrameConfig: "68x18",
      check: "Yes",
    },
    {
      prod: "_037",
      size: "Poster",
      height: 32,
      minHeight: 18,
      width: 92,
      minWidth: 78,
      frameConfig: "32x92",
      minFrameConfig: "18x78",
      check: "Yes",
    },
    {
      prod: "_038",
      size: "Poster",
      height: 92,
      minHeight: 78,
      width: 32,
      minWidth: 18,
      frameConfig: "92x32",
      minFrameConfig: "78x18",
      check: "Yes",
    },
    {
      prod: "_039",
      size: "Poster",
      height: 42,
      minHeight: 28,
      width: 42,
      minWidth: 28,
      frameConfig: "42x42",
      minFrameConfig: "28x28",
      check: "Yes",
    },
    {
      prod: "_040",
      size: "Poster",
      height: 42,
      minHeight: 28,
      width: 52,
      minWidth: 38,
      frameConfig: "42x52",
      minFrameConfig: "28x38",
      check: "Yes",
    },
    {
      prod: "_041",
      size: "Poster",
      height: 52,
      minHeight: 38,
      width: 42,
      minWidth: 28,
      frameConfig: "52x42",
      minFrameConfig: "38x28",
      check: "Yes",
    },
    {
      prod: "_042",
      size: "Poster",
      height: 42,
      minHeight: 28,
      width: 62,
      minWidth: 48,
      frameConfig: "42x62",
      minFrameConfig: "28x48",
      check: "Yes",
    },
    {
      prod: "_043",
      size: "Poster",
      height: 62,
      minHeight: 48,
      width: 42,
      minWidth: 28,
      frameConfig: "62x42",
      minFrameConfig: "48x28",
      check: "Yes",
    },
    {
      prod: "_044",
      size: "Poster",
      height: 42,
      minHeight: 28,
      width: 72,
      minWidth: 58,
      frameConfig: "42x72",
      minFrameConfig: "28x58",
      check: "Yes",
    },
    {
      prod: "_045",
      size: "Poster",
      height: 72,
      minHeight: 58,
      width: 42,
      minWidth: 28,
      frameConfig: "72x42",
      minFrameConfig: "58x28",
      check: "Yes",
    },
    {
      prod: "_046",
      size: "Poster",
      height: 42,
      minHeight: 28,
      width: 82,
      minWidth: 68,
      frameConfig: "42x82",
      minFrameConfig: "28x68",
      check: "Yes",
    },
    {
      prod: "_047",
      size: "Poster",
      height: 82,
      minHeight: 68,
      width: 42,
      minWidth: 28,
      frameConfig: "82x42",
      minFrameConfig: "68x28",
      check: "Yes",
    },
    {
      prod: "_048",
      size: "Poster",
      height: 42,
      minHeight: 28,
      width: 92,
      minWidth: 78,
      frameConfig: "42x92",
      minFrameConfig: "28x78",
      check: "Yes",
    },
    {
      prod: "_049",
      size: "Poster",
      height: 92,
      minHeight: 78,
      width: 42,
      minWidth: 28,
      frameConfig: "92x42",
      minFrameConfig: "78x28",
      check: "Yes",
    },
    {
      prod: "_050",
      size: "Poster",
      height: 52,
      minHeight: 38,
      width: 52,
      minWidth: 38,
      frameConfig: "52x52",
      minFrameConfig: "38x38",
      check: "Yes",
    },
    {
      prod: "_051",
      size: "Poster",
      height: 52,
      minHeight: 38,
      width: 62,
      minWidth: 48,
      frameConfig: "52x62",
      minFrameConfig: "38x48",
      check: "Yes",
    },
    {
      prod: "_052",
      size: "Poster",
      height: 62,
      minHeight: 48,
      width: 52,
      minWidth: 38,
      frameConfig: "62x52",
      minFrameConfig: "48x38",
      check: "Yes",
    },
    {
      prod: "_053",
      size: "Poster",
      height: 52,
      minHeight: 38,
      width: 72,
      minWidth: 58,
      frameConfig: "52x72",
      minFrameConfig: "38x58",
      check: "Yes",
    },
    {
      prod: "_054",
      size: "Poster",
      height: 72,
      minHeight: 58,
      width: 52,
      minWidth: 38,
      frameConfig: "72x52",
      minFrameConfig: "58x38",
      check: "Yes",
    },
    {
      prod: "_055",
      size: "Poster",
      height: 52,
      minHeight: 38,
      width: 82,
      minWidth: 68,
      frameConfig: "52x82",
      minFrameConfig: "38x68",
      check: "Yes",
    },
    {
      prod: "_056",
      size: "Poster",
      height: 82,
      minHeight: 68,
      width: 52,
      minWidth: 38,
      frameConfig: "82x52",
      minFrameConfig: "68x38",
      check: "Yes",
    },
    {
      prod: "_057",
      size: "Poster",
      height: 52,
      minHeight: 38,
      width: 92,
      minWidth: 78,
      frameConfig: "52x92",
      minFrameConfig: "38x78",
      check: "Yes",
    },
    {
      prod: "_058",
      size: "Poster",
      height: 92,
      minHeight: 78,
      width: 52,
      minWidth: 38,
      frameConfig: "92x52",
      minFrameConfig: "78x38",
      check: "Yes",
    },
    {
      prod: "_059",
      size: "Poster",
      height: 62,
      minHeight: 48,
      width: 62,
      minWidth: 48,
      frameConfig: "62x62",
      minFrameConfig: "48x48",
      check: "Yes",
    },
    {
      prod: "_060",
      size: "Poster",
      height: 62,
      minHeight: 48,
      width: 72,
      minWidth: 58,
      frameConfig: "62x72",
      minFrameConfig: "48x58",
      check: "Yes",
    },
    {
      prod: "_061",
      size: "Poster",
      height: 72,
      minHeight: 58,
      width: 62,
      minWidth: 48,
      frameConfig: "72x62",
      minFrameConfig: "58x48",
      check: "Yes",
    },
    {
      prod: "_062",
      size: "Poster",
      height: 62,
      minHeight: 48,
      width: 82,
      minWidth: 68,
      frameConfig: "62x82",
      minFrameConfig: "48x68",
      check: "Yes",
    },
    {
      prod: "_063",
      size: "Poster",
      height: 82,
      minHeight: 68,
      width: 62,
      minWidth: 48,
      frameConfig: "82x62",
      minFrameConfig: "68x48",
      check: "Yes",
    },
    {
      prod: "_064",
      size: "Poster",
      height: 62,
      minHeight: 48,
      width: 92,
      minWidth: 78,
      frameConfig: "62x92",
      minFrameConfig: "48x78",
      check: "Yes",
    },
    {
      prod: "_065",
      size: "Poster",
      height: 92,
      minHeight: 78,
      width: 62,
      minWidth: 48,
      frameConfig: "92x62",
      minFrameConfig: "78x48",
      check: "Yes",
    },
    {
      prod: "_066",
      size: "Poster",
      height: 72,
      minHeight: 58,
      width: 72,
      minWidth: 58,
      frameConfig: "72x72",
      minFrameConfig: "58x58",
      check: "Yes",
    },
    {
      prod: "_067",
      size: "Poster",
      height: 72,
      minHeight: 58,
      width: 82,
      minWidth: 68,
      frameConfig: "72x82",
      minFrameConfig: "58x68",
      check: "Yes",
    },
    {
      prod: "_068",
      size: "Poster",
      height: 82,
      minHeight: 68,
      width: 72,
      minWidth: 58,
      frameConfig: "82x72",
      minFrameConfig: "68x58",
      check: "Yes",
    },
    {
      prod: "_069",
      size: "Poster",
      height: 72,
      minHeight: 58,
      width: 92,
      minWidth: 78,
      frameConfig: "72x92",
      minFrameConfig: "58x78",
      check: "Yes",
    },
    {
      prod: "_070",
      size: "Poster",
      height: 92,
      minHeight: 78,
      width: 72,
      minWidth: 58,
      frameConfig: "92x72",
      minFrameConfig: "78x58",
      check: "Yes",
    },
    {
      prod: "_071",
      size: "Poster",
      height: 82,
      minHeight: 68,
      width: 82,
      minWidth: 68,
      frameConfig: "82x82",
      minFrameConfig: "68x68",
      check: "Yes",
    },
    {
      prod: "_072",
      size: "Poster",
      height: 82,
      minHeight: 68,
      width: 92,
      minWidth: 78,
      frameConfig: "82x92",
      minFrameConfig: "68x78",
      check: "Yes",
    },
    {
      prod: "_073",
      size: "Poster",
      height: 92,
      minHeight: 78,
      width: 82,
      minWidth: 68,
      frameConfig: "92x82",
      minFrameConfig: "78x68",
      check: "Yes",
    },
    {
      prod: "_074",
      size: "Poster",
      height: 92,
      minHeight: 78,
      width: 92,
      minWidth: 78,
      frameConfig: "92x92",
      minFrameConfig: "78x78",
      check: "Yes",
    },
  ];
  var sizeMappingDistance = sizeMapping.map(function (item) {
    return item.distance;
  });
  var sizeMappingOpt1 = sizeMapping.map(function (item) {
    return item.opt1;
  });
  var sizeMappingOpt2 = sizeMapping.map(function (item) {
    return item.opt2;
  });
  var sizeMappingOpt3 = sizeMapping.map(function (item) {
    return item.opt3;
  });
  var results = [];
  var form = document.querySelector("#calculatorForm");
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    results = [];
    var inputHeight = parseFloat(document.querySelector("#frame-height").value);
    var inputWidth = parseFloat(document.querySelector("#frame-width").value);
    calculate(inputHeight, inputWidth);
    console.log(results);
    renderResults();
  });
  function calculate(inputHeight, inputWidth) {
    if (isNaN(inputHeight) || isNaN(inputWidth)) {
      errors.push("Wrong Numbers");
      return;
    }

    /**
     * Option 1
     */

    var result1 = {};
    var heightKitSize1 = xlookup(
      inputHeight,
      sizeMappingDistance,
      sizeMappingOpt1
    );
    var widthKitSize1 = xlookup(
      inputWidth,
      sizeMappingDistance,
      sizeMappingOpt1
    );
    var minFrameSize1 = getMinFrameSize(heightKitSize1, widthKitSize1);
    var validFrameSize1 = determineSize(minFrameSize1, inputHeight, inputWidth);
    var heightConfig1 = getProduct("height", validFrameSize1, inputHeight);
    var widthConfig1 = getProduct("width", validFrameSize1, inputWidth);
    var totalConfig1 = heightConfig1 + "x" + widthConfig1;
    var finalConfigFrame1 = validProductFrameConfig(
      validFrameSize1,
      totalConfig1
    );
    if (!validFrameSize1 || validFrameSize1 != "None") {
      result1.kitLabel = "Best Pop-up Frame kit";
      result1.kitSize = validFrameSize1;
      result1.frame = finalConfigFrame1;
      results.push(result1);
    }

    /**
     * Option 2
     */
    var result2 = {};
    var heightKitSize2 = xlookup(
      inputHeight,
      sizeMappingDistance,
      sizeMappingOpt2
    );
    var widthKitSize2 = xlookup(
      inputWidth,
      sizeMappingDistance,
      sizeMappingOpt2
    );
    var minFrameSize2 = getMinFrameSize(heightKitSize2, widthKitSize2);
    var validFrameSize2 = determineSize(minFrameSize2, inputHeight, inputWidth);
    var heightConfig2 = getProduct("height", validFrameSize2, inputHeight);
    var widthConfig2 = getProduct("width", validFrameSize2, inputWidth);
    var totalConfig2 = heightConfig2 + "x" + widthConfig2;
    var finalConfigFrame2 = validProductFrameConfig(
      validFrameSize2,
      totalConfig2
    );
    if (!validFrameSize2 || validFrameSize2 != "None") {
      result2.kitLabel = "Alternative kit";
      result2.kitSize = validFrameSize2;
      result2.frame = finalConfigFrame2;
      results.push(result2);
    }

    /**
     * Option 3
     */
    var result3 = {};
    var heightKitSize3 = xlookup(
      inputHeight,
      sizeMappingDistance,
      sizeMappingOpt3
    );
    var widthKitSize3 = xlookup(
      inputWidth,
      sizeMappingDistance,
      sizeMappingOpt3
    );
    var minFrameSize3 = getMinFrameSize(heightKitSize3, widthKitSize3);
    var validFrameSize3 = determineSize(minFrameSize3, inputHeight, inputWidth);
    var heightConfig3 = getProduct("height", validFrameSize3, inputHeight);
    var widthConfig3 = getProduct("width", validFrameSize3, inputWidth);
    var totalConfig3 = heightConfig3 + "x" + widthConfig3;
    var finalConfigFrame3 = validProductFrameConfig(
      validFrameSize3,
      totalConfig3
    );
    if (!validFrameSize3 || validFrameSize3 != "None") {
      result3.kitLabel = "Alternative kit";
      result3.kitSize = validFrameSize3;
      result3.frame = finalConfigFrame3;
      results.push(result3);
    }
  }
  function renderResults() {
    var resultsDiv = document.querySelector(".calc-results");
    resultsDiv.innerHTML = "";
    if (results.length < 1) {
      resultsDiv.insertAdjacentHTML("beforeend", "<p>Not in database</p>");
    }
    for (var i = 0; i < results.length; i++) {
      var result = results[i];
      var resultHTML = renderResult(result);
      if (resultHTML) {
        resultsDiv.insertAdjacentHTML("beforeend", resultHTML);
      }
    }
  }
  function renderResult(result) {
    var productSize = result.kitSize;
    var html = "";
    if (productSize != "None") {
      var frame = result.frame.split("x");
      var kitLabel = result.kitLabel;
      html +=
        '<div class="calc-result calc-result-best"><div class="calc-result__item calc-result__size">\n                <span class="calc-result__label">'
          .concat(
            kitLabel,
            '</span>\n                <span class="calc-result__value h3 color-scheme color-scheme--2">'
          )
          .concat(
            productSize,
            '</span>\n            </div>\n\n            <div class="calc-result__item calc-result__side-1">\n                <span class="calc-result__label">Two sides at:</span>\n                <span class="calc-result__value h3 color-scheme color-scheme--2">'
          )
          .concat(
            frame[0],
            '</span>\n            </div>\n            <div class="calc-result__item calc-result__side-2">\n                <span class="calc-result__label">Two sides at:</span>\n                <span class="calc-result__value h3 color-scheme color-scheme--2">'
          )
          .concat(frame[1], "</span>\n            </div>\n        </div>");
    }
    return html;
  }
  function xlookup(lookupValue, lookupArray, returnArray) {
    var ifNotFound =
      arguments.length > 3 && arguments[3] !== undefined
        ? arguments[3]
        : "None";
    var matchMode =
      arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var searchMode =
      arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    // matchMode and searchMode are not used in this simplified implementation
    for (var i = 0; i < lookupArray.length; i++) {
      if (lookupArray[i] === lookupValue) {
        return returnArray[i];
      }
    }
    return ifNotFound;
  }
  function getMinFrameSize(heightKitSize, widthKitSize) {
    if (heightKitSize === "None" || widthKitSize === "None") {
      return "None";
    }
    if (heightKitSize === "Poster" || widthKitSize === "Poster") {
      return "Poster";
    }
    if (heightKitSize === "Medium" || widthKitSize === "Medium") {
      return "Medium";
    }
    if (heightKitSize === "Small" || widthKitSize === "Small") {
      return "Small";
    }
    return "None";
  }
  function determineSize(minimumFrameSize, inputHeight, inputWidth) {
    if (minimumFrameSize === "None") {
      return "None";
    }
    if (minimumFrameSize === "Poster" && inputHeight > 17 && inputWidth > 17) {
      return "Poster";
    }
    if (minimumFrameSize === "Medium" && inputHeight > 8 && inputWidth > 8) {
      return "Medium";
    }
    if (minimumFrameSize === "Small" && inputHeight > 8 && inputWidth > 8) {
      return "Small";
    }
    return "None";
  }
  function getProduct(key, size, inputDim) {
    if (size === "None") {
      return "None";
    }
    var productList;
    if (size === "Small") {
      productList = smallProductList;
    } else if (size === "Medium") {
      productList = mediumProductList;
    } else if (size === "Poster") {
      productList = posterProductList;
    } else {
      return "None";
    }
    var filteredProducts = productList.filter(function (product) {
      return product[key] >= inputDim;
    });
    if (filteredProducts.length > 0) {
      return filteredProducts[0][key];
    } else {
      return "Not in database";
    }
  }
  function validProductFrameConfig(size, frameConfig) {
    if (size === "None") {
      return "N/A";
    }
    var productList = [];
    if (size === "Small") {
      productList = smallProductList;
    } else if (size === "Medium") {
      productList = mediumProductList;
    } else if (size === "Poster") {
      productList = posterProductList;
    } else {
      return "N/A";
    }
    var product = productList.find(function (product) {
      return product.frameConfig === frameConfig;
    });
    if (product) {
      return product.frameConfig;
    } else {
      return "N/A";
    }
  }
});
